<template>
  <div>
    <div class="showlabel">
      <h4>选择题库</h4>
      <div class="testtype" v-if="$parent.iseditmode === undefined">
        组件模式：{{ groupmode }}
      </div>
      <div class="testtype" v-if="$parent.iseditmode === undefined">
        命题方式：{{ unified }}
      </div>
      <div class="testtype addtesttypebtn" @click="addtextSon">添加试卷</div>
    </div>
    <div class="baic_content">
      <!-- 添加题库按钮 -->
      <div v-if="isaddtest">
        <div class="addtestbtn">
          <div class="addtestbtncontent1" @click="addtextSon" id="guide-page-two-sjzj"></div>
        </div>
        <h4>添加试卷</h4>
      </div>
      <!-- 试题设置弹窗 -->
      <TwoSon ref="addtextSon" @multipleData="multipleData" />
      <div v-if="!isaddtest">
        <!-- 选择试题列表 -->
        <div class="question_content" id="guide-page-two-sjzj-one">
          <h4 class="select">选择题库</h4>
          <div class="question_contents">
            <div class="questions">
              <h5>平台题库</h5>
              <el-cascader-panel
                :options="options"
                :props="props"
                @change="gettopicInfo"
                v-model="val"
                ref="cascader"
                clearable
                class="taansfer"
              >
                <template slot-scope="{ data }">
                  <span v-if="data.PaperTitle">{{
                    data.PaperTitle + `(${data.TestCount}题)`
                  }}</span>
                  <span v-if="!data.PaperTitle">{{
                    data.Style + `(${data.TestCount}题)`
                  }}</span>
                </template>
              </el-cascader-panel>
            </div>
          </div>
        </div>
      </div>
      <!-- 按钮 -->
      <div class="operation">
        <el-button
          class="succ_btn"
          @click="
            cutcoms(0);
            destroy();
          "
          >上一步</el-button
        >
        <el-button type="success" class="submit_btn" @click="nexttothree"
          >下一步</el-button
        >
      </div>
    </div>
    <!-- 弹窗 -->
  </div>
</template>

<script>
import $utils from '@/utils/commonUtils';
import { getPaperStryle } from "@/api/examination.js";
import loginvuex from "@/store/index";
import TwoSon from "./TwoSon.vue";
export default {
  name:'Combinpagetwo',
  props: ["cutcoms"],
  components: {
    TwoSon,
  },
  data() {
    return {
      isaddtest: true, //添加题库按钮的显示与隐藏true就是显示，false就是隐藏
      testtype: "1",
      props: {
        multiple: true,
        value: "PaperStyleID",
        children: "Child",
        emitPath: false,
      },
      cssisselect0: "",
      cssisselect1: "",
      cssisselect2: "",
      selectlArr: [], // 第二页发送第三页数据
      groupmode: "", //组卷模式
      unified: "", //统一命题
      val: [],
      options: [],
      softApp: {},
      sonData: [],
    };
  },
  methods: {
    gettopicInfo(e) {
      console.log("选中val========",this.val);
      let keyName = this.$refs.cascader.getCheckedNodes();
      console.log("keyName=====",keyName);
      if (keyName && keyName.length) {
        for (let key in this.softApp) {
          keyName.forEach((item) => {
            const obj = item.data;
            const softData = this.softApp[key];
            if (key.indexOf(obj.MainPaperID) >= 0) {
              if (obj.PaperStyleID && obj.label && obj.SourceStyleID) {
                softData.push(`${obj.SourceStyleID}|${obj.label}|${obj.PaperStyleID}`);
              }
            }
          });
        }
        console.log("选中this.softApp========",this.softApp);
      }
    },
    totesttypedata(e) {
      //!!!!!!!!!!!!!!!!!!!!!第二次采用点击的方式，思想是点击第一级，第二级数据动态改变，第二级默认展示第一个，然后开始展示第三级。
      console.log(e);
      this.seriesof = e.map((item) => {
        return item.label; //弹窗弹，对三级数据的第一级进行初始化第一次显示，这个时候还不知道第二级数据是啥，只有任意点击了一个按钮之后，才会显示第二级数据。
      });
      this.isselect0(0);
      //  console.log(this.seriesof);
      this.category = e[0].children.map((item) => {
        //但是这里采用默认第一次选中第一个按钮，第二级菜单就展示的是第一级菜单点击第一个按钮的状态，
        return item.label;
      });
      this.isselect1(0);
      this.subjects = e[0].children[0].children.map((item) => {
        //这里也是采用默认第一次选中后的数据，第三级菜单就采用第二级选中后的数据，然后就显示第三级。
        return item.label;
      });
    },
    addquestionbank() {
      this.$refs.addtestdialog.dialogVisible = true; //开启弹窗
      //   this.isaddtest = false;  隐藏添加题库按钮 ，展示题库具体列表
      console.log(this.$refs.addtestdialog.dialogVisible);
    },
    // 试题设置弹窗
    addtextSon() {
      this.$refs.addtextSon.dialogVisibleSon = true; // 开启弹窗
      this.$refs.addtextSon.addExaminList(); // 调用考试的列表接口
      this.$refs.addtextSon.addPracticeInList(); // 调用练习的列表接口
      // console.log( this.$refs.addtextSon.dialogVisibleSon,'滴滴滴')
    },
    changetesttype(type) {
      if (this.testtype !== type) {
        if (this.testtype === "1") {
          this.testtype = "0";
        } else {
          this.testtype = "1";
        }
      }
    },
    // 赋值操作
    multipleData(data) {
      console.log("multipleData=======",data);
      let arrs = [];
      data.forEach((item) => {
        arrs.push(item.MainPaperID);
        item.value = item.MainPaperID;
        item.label = item.PaperTitle;
        item.children = [];
      });
      this.addList(arrs, data);
    },
    // 级联接口
    async addList(arrs, data) {
      let params = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        mainPaperIDList: `[${arrs}]`,
      };
      const Data = await getPaperStryle(params);
      if (Data.status === 200) {
        let children_arr = Data.data.Data;
        console.log("children_arr========",children_arr)
        children_arr.forEach((e) => {
          e.Child.forEach((c) => {
            c.value = c.PaperStyleID;
            c.label = c.Style;
          });
        });
        data.forEach((d) => {
          children_arr.forEach((ca) => {
            if (d.MainPaperID == ca.MainPaperID) {
              if (!this.softApp.hasOwnProperty(`${ca.PaperTitle}|${d.MainPaperID}`)){
                this.softApp[`${ca.PaperTitle}|${d.MainPaperID}`] = [];
              }
              ca.Child = ca.Child.map((item) => {
                item.MainPaperID = d.MainPaperID;
                return item;
              });
              d.children = ca.Child;
            }
          });
        });
        this.options = children_arr;
        console.log("options=====",this.options);
      } else {
        this.$message({
          type: "info",
          message: "数据获取不到",
        });
      }
      console.log("begin========softApp",this.softApp);
    },
    fileData() {},
    isselect0(index) {
      //第一级按钮，按钮点击后标识为选中状态
      this.cssisselect0 = index;
    },
    isselect1(index) {
      //第二级按钮，按钮点击后标识为选中状态
      this.cssisselect1 = index;
    },
    isselect2(index) {
      //第三级按钮，按钮点击后标识为选中状态
      this.cssisselect2 = index;
    },
    nexttothree() {
      let selectl = "";
      console.log("试卷类型======",this.isaddtest);
      if (this.isaddtest) {
        this.$message({
          message: "请添加试卷",
          type: "warning",
        });
        return;
      }
      try {
        selectl = this.$refs["cascader"].getCheckedNodes(true); // 叶子节点
        console.log(selectl,'sdasssssssssssssss');
        this.selectlArr = selectl.map((item) => {
          return item.data;
        });
        console.log("this.selectlArr========",this.selectlArr);
        this.$parent.PaperStyleArr = this.selectlArr; // 发送数据给父组件
        console.log("this.PaperStyleArr========",this.$parent.PaperStyleArr);
      } catch (error) {
        this.$message.error("没有添加题库");
      }
      //编辑进入，收集数据，进行试卷随机组卷渲染。
      console.log("iseditmode========",this.$parent.iseditmode)
      if (this.$parent.iseditmode !== undefined) {
        this.editnext();
        return;
      }
      if (this.$parent.testmode === "试卷组卷") {
        if (this.isaddtest !== true) {
          if (this.selectlArr.length > 0) {
            this.cutcoms(2);

            this.$parent.isnewtestaas = 1;



            this.$emit("setSoftApp", this.softApp);
          } else {
            this.$message.error("没有添加题型");
          }
        }
      }
    },
    destroy() {
      this.$destroy();
    },
    //编辑进来数据还原
    reeditdata() {
      this.isaddtest = false;
      // console.log("SoftApp==========",
      //   Object.keys(JSON.parse(this.$parent.paperinfomation[1].Config).SoftApp)
      // );
      let newarr = Object.keys(
        JSON.parse(this.$parent.paperinfomation[1].Config).SoftApp
      ).map((item) => {
        return item.split("|")[1];
      });
      let newarr1 = newarr.map((item) => {
        let newobj = {};
        newobj["MainPaperID"] = item;
        return newobj;
      });
      this.addList(newarr, newarr1);
      // console.log("CookieCpt==========",JSON.parse(this.$parent.paperinfomation[1].Config).CookieCpt);
      this.val = JSON.parse(this.$parent.paperinfomation[1].Config).CookieCpt.PaperStyleID;
      this.softApp = JSON.parse(this.$parent.paperinfomation[1].Config).SoftApp;
      // console.log("begin====softApp",this.softApp);
    },
    //编辑进入下一步
    editnext() {
      this.$nextTick(()=>{
         this.$parent.random_exam_data.pageStyelArr = this.selectlArr;
         this.$parent.random_exam_data.softApp = this.softApp;
         this.$parent.random_exam_data.SelectCpt = this.selectlArr.map((item) => {
                 return item.PaperStyleID;
              });
      this.$parent.random_exam_data.CookieCpt.PaperStyleID =
        this.$parent.random_exam_data.SelectCpt;        
      this.cutcoms(2);
      console.log(this.$parent.testinfomation.ExamID,'ExamID');
      // console.log(this.selectlArr,'this.selectlArr',this.$parent.random_exam_data.pageStyelArr);
      // console.log(this.$parent.paperinfomation[1],'paperinfomation========>');
      })
    
      // console.log(this.$parent.random_exam_data);
    },
  },
  watch: {
    async isaddtest(){
      if(!this.isaddtest){
        let guideSteps = await $utils.getUserGuideList("zxksPageTwoOneSjSteps");
        this.driver = $utils.getGuideDriver();
        setTimeout(() => {
          this.$nextTick(() => {
            $utils.initGuideDriver(this.driver,guideSteps);
          })
        },500);
      }
    },
  },
  created() {
    if (this.$parent.iseditmode !== undefined) {
      //编辑模式下进来。
      this.reeditdata();
      return;
    }
    this.groupmode = this.$parent.testmode;
    this.unified = this.$parent.checkmode;
  },
  async activated(){
    let guideSteps = await $utils.getUserGuideList("zxksPageTwoSjSteps");
    this.driver = $utils.getGuideDriver();
    setTimeout(() => {
      this.$nextTick(() => {
        $utils.initGuideDriver(this.driver,guideSteps);
      })
    },1000);
  }
};
</script>

<style lang="scss" scoped>
.baic_content {
  //1
  //background-color: rgb(255, 255, 255);
  min-width: 1527px;
  padding-bottom: 50px;
  border-radius: 14px 14px 14px 14px;
  h3 {
    display: inline-block;
    width: 100%;
    height: 60px;
    background: #cce7ff;
    border-radius: 4px 4px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    padding-top: 17px;
    padding-left: 24px;
  }
  h4 {
    text-align: center;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 20px;
    color: #1890ff;
    cursor: pointer;
  }
}
.operation {
  display: flex;
  justify-content: center;
  align-items: center;
  // margin: 100px 0 70px 0;
  padding-bottom: 100px;
  background-color: #ffffff;
  .succ_btn {
    width: 162px;
    height: 50px;
    background: #eeeeee;
    color: #999999;
    margin-right: 90px;
  }
  .submit_btn {
    width: 162px;
    height: 50px;
    background: #0fc758;
    color: #ffffff;
  }
}
.showlabel {
  width: 100%;
  height: 98px;
  background-color: rgb(255, 255, 255);
  margin-bottom: 24px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  h4 {
    //background-color: antiquewhite;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 20px;
    color: #333333;
    padding-left: 24px;
    padding-right: 24px;
  }
  .testtype {
    padding-left: 24px;
    padding-right: 24px;
    height: 50px;
    background: #eeeeee;
    opacity: 1;
    border-radius: 4px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 50px;
    margin-right: 50px;
    &:nth-child(4) {
      background-color: #1890ff;
      color: #ffffff;
      padding-left: 49px;
      padding-right: 49px;
      cursor: pointer;
    }
  }
  .addtesttypebtn {
    background-color: #1890ff;
    color: #ffffff;
  }
}
.addtestbtn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 370px;
  padding-top: 80px;
  background-color: #ffffff;
  & + h4 {
    background-color: #ffffff;
    padding-bottom: 100px;
  }
  .addtestbtncontent1 {
    width: 200px;
    height: 200px;
    background-image: url(../../../../../../assets/addtesttype.png);
    background-size: 100%;
    cursor: pointer;
    &:hover {
      width: 290px;
      height: 290px;
      background-image: url(../../../../../../assets/addtesttypeactive.png);
      background-size: 100%;
    }
  }
}

//下面是列表的样式
.select {
  height: 42px;
  background: #1890ff;
  margin-top: 20px;
  border-radius: 10px 10px 0px 0px;
  font-size: 15px !important;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 42px !important;
  padding-left: 24px;
  color: #ffffff !important;
  text-align: left !important;
}
.question_content {
  background-color: rgb(255, 255, 255);
  padding-bottom: 60px;
}
.question_contents {
  display: flex;
  .questions {
    width: 100%;
  }
  h5 {
    height: 60px;
    font-size: 18px;
    background: #cce7ff;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    line-height: 60px;
    padding-left: 14px;
  }
}
::v-deep .is-bordered {
  > :nth-child(1) {
    min-width: 250px;
    width: 50%;
    border-right: none;
  }
  > :nth-child(2) {
    min-width: 250px;
    width: 50%;
    border-right: none;
  }
}
::v-deep .el-cascader-menu__wrap {
  height: 430px;
}
::v-deep .el-cascader-node {
  height: 52px;
  border-bottom: 1px solid #eeeeee;
  &:focus {
    background: linear-gradient(90deg, #ffffff 0%, #8fcaff 100%);
    // background-image: url('../../../../../../assets/addtesttype.png');
  }
  &:hover {
    background: linear-gradient(90deg, #ffffff 0%, #8fcaff 100%);
  }
}
::v-deep .el-icon-arrow-right {
  display: none; //向右的箭头隐藏
}
::v-deep .el-cascader-menu__list {
  border-right: 1px solid #eeeeee;
}
::v-deep .in-active-path {
  //更改选中后的属性
  background: linear-gradient(90deg, #ffffff 0%, #8fcaff 100%);
}
</style>
